import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import styled from "styled-components/macro";
import { useTranslation } from "react-i18next";
import { SIDELIST_TITLE_BACKGROUND } from "../../helpers/Const";
import { Dispatch, iRootState } from "src/rematch/store";
import { Action } from "@rematch/core";
import { IFiltersState } from "src/rematch/interfaces/states/IFiltersState";
import { setUrlFilter } from "src/gantt/helpers/FilterUtils";

export const FilterPanelStyled = styled.div`
  padding-right: 20px;
  flex: 1 1 auto;
  display: flex;
  justify-content: flex-end;
`;

export const FilterPanelInput = styled.input`
  background: ${SIDELIST_TITLE_BACKGROUND};
  border: 1px solid white;
  padding-left: 4px;
  color: #fff;
  font-size: 14px;
  width: 207px;
  height: 30px;
  ::placeholder {
    color: #ddd;
  }
  &:focus {
    outline: 0;
  }
`;

interface IFilterPanelProps {
  viewIndex: number;
  filters: IFiltersState;
  updateQuickFilter: (searchString: string, viewIndex: number) => Action<{ value: string, viewIndex: number },void>;
}

const QuickFilterPanel = (props: IFilterPanelProps) => {
  const { t } = useTranslation();
  const [quickfilter,setQuickfilter] = useState(props.filters.quickFilters[props.viewIndex].value);
  /* 
  useEffect(() => {
    setUrlFilter(props.filters);
  }, [props.filters]); */
  
  return (
    <FilterPanelStyled>
      <FilterPanelInput
        type="text"
        value={quickfilter}
        placeholder={t("filter.searchplaceholder")}
        onChange={(event) => { 
          setQuickfilter(event.target.value);
          props.updateQuickFilter(event.target.value, props.viewIndex);
        }}
      ></FilterPanelInput>
    </FilterPanelStyled>
  );
};

export default connect(
  (state: iRootState) => ({
    filters: state.filters
  }), 
  (dispatch: Dispatch) => ({
    updateQuickFilter: (searchString: string, viewIndex: number) => dispatch.filters.updateQuickFilter({ value: searchString, viewIndex: viewIndex }),
  })
)(QuickFilterPanel);
